import type { StyleRule } from '@archipro-design/aria';
import { dropdownClassName } from '@archipro-design/aria';
import { textInputSlotClassNames } from '@archipro-design/aria';
import { inputSlotClassNames } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

import { dropdownSlotClassNames } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { FilterDropdownStyle } from './FilterDrawer.style';

const FilterDropdownMobile = {
    marginBottom: pxToRem(6),
    width: pxToRem(380),
    [`& .${dropdownSlotClassNames.container}`]: {
        border: 'none',
        [`& .${dropdownSlotClassNames.itemsList}`]: {
            marginLeft: pxToRem(-6),
            "[aria-hidden='true']": {
                height: 0,
            },
        },
    },
    [`& .${textInputSlotClassNames.primaryContent}`]: {
        [`& .${dropdownClassName}.${inputSlotClassNames.input}`]: {
            height: pxToRem(24),
            marginTop: pxToRem(12.5),
            marginBottom: pxToRem(12.5),
            marginLeft: 0,
            [`& .${dropdownSlotClassNames.selectedItems}`]: {
                marginLeft: pxToRem(8),
            },
            [`& .${svgIconClassName}`]: {
                marginTop: pxToRem(-4),
            },
        },
    },
    [`& .${inputSlotClassNames.icon}`]: {
        [`& .${svgIconClassName}`]: {
            marginTop: pxToRem(18.5),
            marginRight: pxToRem(7.5),
        },
    },
};

export const FilterMonthMobile: StyleRule<{ month: number | null }> = ({
    theme,
    month,
}) => ({
    ...FilterDropdownStyle,
    ...FilterDropdownMobile,
    ...(month === null
        ? {
              [`& .${dropdownSlotClassNames.clearIndicator}`]: {
                  display: 'none',
              },
          }
        : {
              [`& .${inputSlotClassNames.input}`]: {
                  [`& .${dropdownSlotClassNames.triggerButton}`]: {
                      color: theme.siteVariables.colors.charcoal['250'],
                  },
              },
          }),
});

export const FilterYearMobile: StyleRule<{ year: number | null }> = ({
    theme,
    year,
}) => ({
    ...FilterDropdownStyle,
    ...FilterDropdownMobile,
    ...(year !== null && {
        [`& .${inputSlotClassNames.input}`]: {
            [`& .${dropdownSlotClassNames.triggerButton}`]: {
                color: theme.siteVariables.colors.charcoal['250'],
            },
        },
    }),
});
